export default __webpack_public_path__ + "static/media/bg-head.ab63e6e6.png";